module.exports = __webpack_public_path__ + "img/baoche.62259694.png";